
import React from 'react';

interface FlipLogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const FlipLogo = ({ size = 'md', className = '' }: FlipLogoProps) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16'
  };

  return (
    <div className={`${sizeClasses[size]} ${className} relative flex items-center justify-center bg-[#1e1e3c] rounded-xl`}>
      <div className="relative">
        {/* F letter with geometric design */}
        <div className="text-white font-bold text-xl leading-none">
          F
        </div>
        {/* Small pink accent dot */}
        <div className="absolute -top-1 -right-1 w-2 h-2 bg-[#E91E63] rounded-full"></div>
      </div>
    </div>
  );
};

export default FlipLogo;
